<template>
  <div class="article">
    <div class="article-content">
      <div class="article-title">
        <div class="article-title-img">
          <p
            :class="{ 'article-title-long': fontSize === 'big' }"
            v-text="article.post_title"
          ></p>
        </div>
        <h1 v-text="article.post_title"></h1>
      </div>
      <div class="article-detail" v-html="article.post_content"></div>
      <div class="article-foot">
        <div class="article-foot-system">
          <span>操作设备： 电脑</span>
          <span>操作系统： windows 10</span>
          <span>操作版本： WPS Office 2019 PC个人版</span>
        </div>
      </div>
    </div>
    <div class="article-foot-help">
        <div class="article-foot-content" v-if="!feedback">
          <p><strong>此内容对你有帮助吗？</strong></p>
          <div class="article-foot-button">
            <div class="article-foot-useful-button" @click="handleUseful()" >
              <span>有帮助</span>
            </div>
            <div
              class="article-foot-useful-button article-foot-useless-button"
              @click="handleUseless()"
            >
              <span>无帮助</span>
            </div>
          </div>
        </div>
        <div class="article-foot-feedback" v-else>
          <img src="@/static/img/icon_correct.svg" alt="">
          <p>感谢您的反馈!</p>
        </div>
        <div class="article-foot-bottom">
          <p>学堂自习室为用户交流问答内容，未经官方精选加工。但海量内容中，不乏一些有价值技巧，仅供各位同学参考学习。学习官方WPS技巧请至
            <a
              href="https://www.wps.cn/learning/?chan=room"
              target="_blank"
              @click="detailClick('learn')"
              >WPS学堂</a
            ></p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            feedback: false
        };
    },
    props: {
        article: {
            type: Object,
            default: () => {
                return {
                    post_title: '',
                    post_content: ''
                };
            }
        }
    },
    methods: {
        postRead() {
            const id = this.$route.params.id;
            this.$service.learning.postRead(id);
        },

        postUseful() {
            const id = this.$route.params.id;
            this.$service.learning.postUseFul(id);
        },
        postUseless() {
            const id = this.$route.params.id;
            this.$service.learning.postUnuseFul(id);
        },

        handleUseful() {
            this.postUseful();
            this.detailClick('help');
            this.feedback = true;
        },
        handleUseless() {
            this.postUseless();
            this.detailClick('nohelp');
            this.feedback = true;
        },

        detailClick(key) {
            this.$collect.detailsClick(key);
        }
    },
    computed: {
        fontSize() {
            return this.article.post_title.length > 10 ? 'big' : 'small';
        }
    },
    mounted() {
        this.postRead();
    }
};
</script>

<style lang="less" scoped>
.article {
  min-height: calc(100vh - 84px - 102px);
  margin: 0 auto;
  &-content {
    background-color: #ffffff;
    margin: 0 auto;
    > hr {
      width: 98%;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.1);
      border: none;
    }
  }
  &-title {
    background-color: #ffffff;
    > h1 {
      margin-top: 30px;
      font-size: 24px;
    }

    &-img {
      width: 100%;
      height: 138px;
      background-image: url('/learning/room/img/cover_baidu_min.png');
      background-size: contain;

      > p {
        font-size: 16px;
        font-weight: bold;
        color: #222226;
        text-align: center;
        padding-top: 32px;
      }
    }
    &-long {
      margin: 0 auto;
      max-width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &-detail {
    font-size: 14px;
    line-height: 3;
    margin-top: 30px;
    img {
      max-width: 100%;
    }
    p {
      max-width: 100%;
      word-wrap: break-word;
    }
  }
  &-foot {
    &-system {
      padding-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      > span {
        font-size: 14px;
        color: #8C939F;
        line-height: 20px;
      }
    }
    &-help {
      margin: 16px;
      .article-foot-content {
        background: #FFFFFF;
        border-radius: 8px;
        padding: 24px 16px;
        > p {
           margin-top: 0;
        }
      }
      .article-foot-bottom {
        margin-bottom: 0;
      }
    }
    &-content > p {
      margin-top: 40px;
      font-size: 18px;
    }
    &-button {
      margin-top: 20px;
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      user-select: none;
    }
    &-useful-button {
      width: 43%;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #D0D3D8;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
      background-color: #ffffff;
      color: #8b8b8b;
      background: url('/learning/room/img/icon_useful_m.svg') no-repeat 30% 11px;
      background-size: 20px 20px;

      cursor: pointer;
      &:active{
        background: #0065E6;
        background-image: url('/learning/room/img/icon_useful_m_sel.svg');
        background-repeat: no-repeat;
        background-position: 30% 11px;
        background-size: 20px 20px;
        > span {
          color: white;
        }
      }

      > span {
        margin-left: 18.7%;
      }
    }
    &-useless-button {
      color: #8b8b8b;
      background: url('/learning/room/img/icon_useless_m.svg') no-repeat 27% 11px;
      background-size: 20px 20px;

      cursor: pointer;
      &:active {
        color: white;
        background: #0065E6;
        background-image: url('/learning/room/img/icon_useless_m_sel.svg');
        background-size: 20px 20px;
        background-repeat: no-repeat;
        background-position: 27% 11px;
        > span {
          color: white;
        }
      }
      > span {
        margin-left: 18.7%;
      }
    }
    &-feedback {
      margin-top: 40px;
      color: #222226;
      font-size: 18px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;

      > img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
    }
    &-bottom {
      margin-top: 20px;
      font-size: 14px;
      margin-bottom: 100px;
      > p {
        color: #888888;
        line-height: 25px;
      }

      a {
        color: #55a2fe;
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="less">
.article {
  &-detail {
    img {
      max-width: 100% !important;
    }
    p {
      max-width: 100%;
      word-wrap: break-word;
    }
  }
}
</style>
